/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon(
    "versioncontrol.version_explorer",
    require("./rawicons/version_explorer.icon.svg.js")
);

IconRegistry.registerIcon(
    "versioncontrol.commit_push",
    require("./rawicons/commit_push.icon.svg.js")
);

IconRegistry.registerIcon("versioncontrol.commit", require("./rawicons/commit.icon.svg.js"));
